import { useNavigate } from "react-router";
import useQueryParams from "../../hooks/useQueryParams";

const getObjectParam = param => {
  if (!param) return null;
  try {
    return JSON.parse(param);
  } catch {
    return null;
  }
};

const getBooleanParam = param => {
  if (param === "true") return true;
  if (param === "false") return false;
  return null;
};

const getActiveParam = param => {
  if (param === "false") return false;
  if (param === "all") return null;
  return true;
};

const resolveSetterValue = (nextOrUpdater, current) =>
  typeof nextOrUpdater === "function" ? nextOrUpdater(current) : nextOrUpdater;

export default function useWarehouseFilters() {
  const navigate = useNavigate();
  const queryParams = useQueryParams();

  const height = getObjectParam(queryParams.get("height"));
  const occupied = getBooleanParam(queryParams.get("occupied"));
  const locationTypeParam = queryParams.get("locationType");
  const locationTypes = locationTypeParam ? [locationTypeParam] : [];
  const active = getActiveParam(queryParams.get("active"));

  const setOccupied = newOccupied => {
    const resolvedOccupied = resolveSetterValue(newOccupied, occupied);
    const params = new URLSearchParams(queryParams.toString());
    if (typeof resolvedOccupied === "boolean") {
      params.set("occupied", String(resolvedOccupied));
    } else {
      params.delete("occupied");
    }
    params.delete("page");
    navigate({ search: params.toString() });
  };

  const setHeight = (newHeight, newOccupied) => {
    const params = new URLSearchParams(queryParams.toString());
    if (newHeight) {
      params.set("height", JSON.stringify(newHeight));
    } else {
      params.delete("height");
    }
    if (newOccupied !== undefined) {
      const resolvedOccupied = resolveSetterValue(newOccupied, occupied);
      if (typeof resolvedOccupied === "boolean") {
        params.set("occupied", String(resolvedOccupied));
      } else {
        params.delete("occupied");
      }
    }
    params.delete("page");
    navigate({ search: params.toString() });
  };

  const setLocationTypes = newLocationTypes => {
    const params = new URLSearchParams(queryParams.toString());
    if (newLocationTypes?.length > 0) {
      params.set("locationType", newLocationTypes[0]);
    } else {
      params.delete("locationType");
    }
    params.delete("page");
    navigate({ search: params.toString() });
  };

  const setActive = newActive => {
    const resolvedActive = resolveSetterValue(newActive, active);
    const params = new URLSearchParams(queryParams.toString());
    if (resolvedActive === false) {
      params.set("active", "false");
    } else if (resolvedActive === null) {
      params.set("active", "all");
    } else {
      params.delete("active");
    }
    params.delete("page");
    navigate({ search: params.toString() });
  };

  const clearFilters = () => {
    const params = new URLSearchParams(queryParams.toString());
    params.delete("height");
    params.delete("occupied");
    params.delete("locationType");
    params.delete("active");
    params.delete("page");
    navigate({ search: params.toString() });
  };

  return {
    height,
    occupied,
    locationTypes,
    active,
    setHeight,
    setOccupied,
    setLocationTypes,
    setActive,
    clearFilters,
  };
}
